import { jsx as i, jsxs as S, Fragment as C } from "react/jsx-runtime";
import { c as h } from "../index-Cu0xwYjD.js";
import * as D from "react";
import { never as c } from "../Util/never.js";
import { Spinner as I } from "./Spinner.js";
import { S as v } from "../index-DK6lfaz2.js";
const N = "_button_3ftu4_1", P = "_sizeDefault_3ftu4_12", w = "_sizeCompact_3ftu4_18", T = "_sizeIcon_3ftu4_24", x = "_disabled_3ftu4_35", j = "_stylePrimary_3ftu4_39", B = "_styleSecondary_3ftu4_64", E = "_loading_3ftu4_75", R = "_styleTertiary_3ftu4_93", F = "_styleDestructive_3ftu4_121", L = "_styleInline_3ftu4_145", O = "_fill_3ftu4_149", k = "_loadingChildren_3ftu4_153", q = "_loadingSpinner_3ftu4_157", t = {
  button: N,
  sizeDefault: P,
  sizeCompact: w,
  sizeIcon: T,
  disabled: x,
  stylePrimary: j,
  styleSecondary: B,
  loading: E,
  styleTertiary: R,
  styleDestructive: F,
  styleInline: L,
  fill: O,
  loadingChildren: k,
  loadingSpinner: q
}, n = {
  size: "default",
  buttonStyle: "primary",
  fill: !1,
  disabled: !1,
  loading: !1,
  asChild: !1,
  type: "button"
}, A = D.forwardRef(
  ({
    className: s,
    children: a,
    size: d,
    fill: u,
    disabled: y,
    loading: o,
    buttonStyle: f,
    asChild: r,
    type: _,
    ...m
  }, p) => {
    const l = {
      size: d,
      buttonStyle: f,
      fill: u,
      disabled: y,
      loading: o,
      type: _
    }, e = {
      size: l.size ?? n.size,
      buttonStyle: l.buttonStyle ?? n.buttonStyle,
      fill: l.fill ?? n.fill,
      disabled: l.disabled ?? n.disabled,
      loading: l.loading ?? n.loading,
      asChild: l.asChild ?? n.asChild,
      type: l.type ?? n.type
    }, b = e.disabled || e.loading, g = G(e.buttonStyle), z = H(e.size);
    return /* @__PURE__ */ i(
      r ? v : "button",
      {
        ...m,
        ref: p,
        className: h(
          t.button,
          g,
          z,
          s,
          e.fill && t.fill,
          e.loading && t.loading,
          e.disabled && t.disabled
          // note we're not using
          // disabledOrLoading here. That's because if we're disabled due to
          // loading, we don't want the button to _look_ like it's disabled.
        ),
        disabled: b,
        ...r ? {} : { type: e.type },
        children: o ? /* @__PURE__ */ S(C, { children: [
          /* @__PURE__ */ i("span", { className: t.loadingSpinner, children: /* @__PURE__ */ i(I, {}) }),
          /* @__PURE__ */ i("span", { className: t.loadingChildren, children: a })
        ] }) : a
      }
    );
  }
);
A.displayName = "Button";
const G = (s) => {
  switch (s) {
    case "primary":
      return t.stylePrimary;
    case "secondary":
      return t.styleSecondary;
    case "tertiary":
      return t.styleTertiary;
    case "destructive":
      return t.styleDestructive;
    case "inline":
      return t.styleInline;
    default:
      return c(s);
  }
}, H = (s) => {
  switch (s) {
    case "default":
      return t.sizeDefault;
    case "compact":
      return t.sizeCompact;
    case "icon":
      return t.sizeIcon;
    default:
      return c(s);
  }
};
export {
  A as Button
};
